export default class MarketingClient {
	constructor() {
		this.baseUrl = process.env.MARKETING_API_HOST;
	}
	async getCategoriesById(root_category_id) {
		const url = new URL(`${this.baseUrl}/categories/${root_category_id}`);
		const response = await fetch(url);

		if (!response.ok) {
			throw new Error("Request failed with status " + response.status);
		}

		return await response.json();
	}
}
